<template>
  <div class="d-flex justify-center">
    <div class="half_w">
      <v-card
        class="pa-3 rounded-lg mb-2 container_ann"
        flat
        min-height="200px"
      >
        <v-card flat class="title_ann">
          <v-row>
            <v-col cols="6"><h3>Announcement</h3></v-col>
            <v-col cols="6" v-if="role == 'TF' || role == 'SUPERADMIN'">
              <div class="d-flex justify-end">
                <v-btn
                  color="blue"
                  text
                  @click="createData"
                  class="text-capitalize"
                  ><v-icon>mdi-plus</v-icon> Create New</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-card>
        <div v-if="announ">
          <div v-if="announ.length" class="mt-3">
            <div v-for="(item, i) in announ" :key="i" class="mb-3">
              <div
                class="d-flex align-center my-1"
                v-if="
                  i != 0 &&
                  $date(announ[i].created_at).format('DD MMMM YYYY') !==
                    $date(announ[i - 1].created_at).format('DD MMMM YYYY')
                "
              >
                <h5 style="color: #a2aaad">
                  {{ $date(item.created_at).format("dddd, DD MMMM YYYY") }}
                  &nbsp;
                </h5>
                <v-divider style="border-top-style: dashed"></v-divider>
              </div>
              <div class="d-flex align-center my-1" v-else-if="i == 0">
                <h5 style="color: #a2aaad">
                  {{ $date(item.created_at).format("dddd, DD MMMM YYYY") }}
                  &nbsp;
                </h5>
                <v-divider style="border-top-style: dashed"></v-divider>
              </div>
              <v-card class="cursor">
                <v-img
                  :src="item.foto ? item.foto : cover_ann"
                  gradient="to bottom, rgba(0,0,0,.2), rgba(0,0,0,.5)"
                  height="200px"
                  @click.stop="viewAnouncement(item)"
                >
                  <div
                    class="d-flex flex-column justify-space-between height100"
                  >
                    <div class="d-flex justify-end pa-1">
                      <v-btn
                        fab
                        small
                        class="mr-1"
                        depressed
                        v-if="role == 'TF' || role == 'SUPERADMIN'"
                        @click.stop="updateData(item)"
                        ><v-icon color="blue">mdi-pencil</v-icon></v-btn
                      >
                      <v-btn
                        v-if="role == 'TF' || role == 'SUPERADMIN'"
                        fab
                        small
                        depressed
                        @click.stop="deleteData(item)"
                        ><v-icon color="red">mdi-trash-can</v-icon></v-btn
                      >
                    </div>
                    <v-card-title
                      class="white--text"
                      v-text="item.title"
                    ></v-card-title>
                  </div>
                </v-img>
              </v-card>
            </div>
          </div>
          <div
            v-if="!announ.length"
            class="d-flex align-center justify-center mt-5"
          >
            No Announcement yet
          </div>
        </div>
      </v-card>
    </div>
    <div class="pa-2">
      <create-announ
        :c_announ="c_announ"
        @close="c_announ = false"
        @fetch="getAnounc"
        :inventory="inventory"
        :foto="foto"
        :type="d_type"
      />
      <view-anoun
        :v_announ="v_announ"
        :inventory="inventory"
        @close="v_announ = false"
      />
      <delete-announ
        :d_announ="d_announ"
        :inventory="inventory"
        @close="d_announ = false"
        @fetch="getAnounc"
      />
    </div>
  </div>
</template>

<script>
import CreateAnnoun from "./createAnnoun.vue";
import ViewAnoun from "./viewAnnoun.vue";
import DeleteAnnoun from "./deleteAnnoun.vue";
import { mapState } from "vuex";
export default {
  name: "allAnnoun",
  components: { CreateAnnoun, ViewAnoun, DeleteAnnoun },
  computed: {
    ...mapState({
      role: (state) => state.role,
      cover_ann: (state) => state.banner_ann,
    }),
  },
  data() {
    return {
      dataSet: null,
      loading: false,
      announ: null,
      c_announ: false,
      v_announ: false,
      inventory: null,
      d_type: "",
      foto: "",
      d_announ: false,
    };
  },
  mounted() {
    this.getAnounc();
  },
  methods: {
    getAnounc() {
      this.loading = true;
      let data = {
        path: `announcement/data?sort=-created_at`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.announ = data.data;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    viewAnouncement(item) {
      this.inventory = item;
      this.v_announ = true;
    },
    createData() {
      let body = {
        title: "",
        description: "",
        image: null,
        year_tf: "all",
      };
      this.inventory = body;
      this.d_type = "create";
      this.c_announ = true;
    },
    updateData(item) {
      let body = {
        id: item.id,
        title: item.title,
        description: item.description,
        image: null,
        year_tf: item.year_tf,
      };
      this.foto = item.foto;
      this.inventory = body;
      this.d_type = "update";
      this.c_announ = true;
    },
    deleteData(item) {
      this.inventory = item;
      this.d_announ = true;
    },
  },
};
</script>

<style scoped>
.container_ann {
  position: relative;
}
</style>